(function () {
  var currentTerms = {};
  var gridObserver = null;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getInputsForSection(sectionId) {
    return document.querySelectorAll('[data-product-search="' + sectionId + '"]');
  }

  function getClearButtonsForSection(sectionId) {
    return document.querySelectorAll('[data-product-search-clear="' + sectionId + '"]');
  }

  function getCountElementsForSection(sectionId) {
    return document.querySelectorAll('[data-product-search-count="' + sectionId + '"]');
  }

  function getGridItems() {
    var grid = document.getElementById('product-grid');
    if (!grid) return [];
    return grid.querySelectorAll('.grid__item[data-product-title]');
  }

  function applyFilter(sectionId, rawValue) {
    var q = (rawValue || '').toLowerCase().trim();
    currentTerms[sectionId] = q;

    getInputsForSection(sectionId).forEach(function (input) {
      if (input.value !== rawValue) input.value = rawValue;
    });

    getClearButtonsForSection(sectionId).forEach(function (btn) {
      if (q.length > 0) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    });

    var items = getGridItems();
    var visible = 0;
    items.forEach(function (item) {
      var title = item.dataset.productTitle || '';
      var hide = q.length > 0 && title.indexOf(q) === -1;
      item.classList.toggle('is-search-hidden', hide);
      if (!hide) visible++;
    });

    getCountElementsForSection(sectionId).forEach(function (countEl) {
      if (q.length === 0) {
        countEl.textContent = '';
        countEl.setAttribute('hidden', '');
      } else {
        countEl.textContent =
          visible === 1
            ? '1 product matches'
            : visible + ' products match';
        countEl.removeAttribute('hidden');
      }
    });
  }

  function bindInput(input) {
    if (input.dataset.searchInit === 'true') return;
    input.dataset.searchInit = 'true';
    var sectionId = input.getAttribute('data-product-search');
    var handler = debounce(function (e) {
      applyFilter(sectionId, e.target.value);
    }, 100);
    input.addEventListener('input', handler);
  }

  function bindClearButton(btn) {
    if (btn.dataset.searchInit === 'true') return;
    btn.dataset.searchInit = 'true';
    var sectionId = btn.getAttribute('data-product-search-clear');
    btn.addEventListener('click', function () {
      applyFilter(sectionId, '');
      var input = document.querySelector('[data-product-search="' + sectionId + '"]');
      if (input) input.focus();
    });
  }

  function reapplyAllActiveTerms() {
    Object.keys(currentTerms).forEach(function (sectionId) {
      var q = currentTerms[sectionId];
      if (q && q.length > 0) applyFilter(sectionId, q);
    });
  }

  function watchProductGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (gridObserver) gridObserver.disconnect();
    gridObserver = new MutationObserver(function () {
      reapplyAllActiveTerms();
    });
    gridObserver.observe(container, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-product-search]').forEach(bindInput);
    document.querySelectorAll('[data-product-search-clear]').forEach(bindClearButton);
    watchProductGrid();
    reapplyAllActiveTerms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
